import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ApteneoZaczytajDanePage = lazy(() =>
	import("@/features/apteneo/zaczytaj-dane-page").then((m) => ({
		default: m.ApteneoZaczytajDanePage,
	})),
);

// Ten sam ksztalt search co `/apteneo/zakupy` — przejscie miedzy stronami
// zachowuje wybrany kwartal.
const searchSchema = z.object({
	rok: z.number().int().min(2000).max(2100).optional().catch(undefined),
	kwartal: z.number().int().min(1).max(4).optional().catch(undefined),
});

export type ApteneoZaczytajDaneSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/apteneo/zaczytaj-dane")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.apteneo.zaczytaj-dane",
			location.pathname,
		);
	},
	component: ApteneoZaczytajDanePage,
	validateSearch: (search: Record<string, unknown>): ApteneoZaczytajDaneSearch =>
		searchSchema.parse(search),
});
